import React from 'react'
import { withStyles, FormHelperText } from '@material-ui/core';
import PropTypes from 'prop-types';
import GridBlock from './GridBlock';
import getObjectValue from 'libs/getObjectValue'

const style = theme => ({
	root: {

	},
	text: {
		margin: 0,
		marginBottom: theme.spacing(1)
	}
})

function ErrorText({
	classes,
	children,
	idList,
	formikProps,
}) {

	let errorText = undefined;

	for (let i in idList) {
		const id = idList[i];
		const errorValue = getObjectValue(id, formikProps.errors, '')
		const touched = getObjectValue(id, formikProps.touched, false)
		const isError = !!errorValue && touched;
		if (isError) {
			errorText = errorValue;
			break;
		}
	}

	return (
		<GridBlock column >
			{children}
			{errorText &&
				<FormHelperText className={classes.text} error>{errorText}</FormHelperText>
			}
		</GridBlock>
	)
}

ErrorText.propTypes = {
	classes: PropTypes.any,
	children: PropTypes.any,
	idList: PropTypes.array,
	formikProps: PropTypes.object.isRequired,
}

ErrorText.defaultProps = {
	idList: []
}

export default withStyles(style)(ErrorText);